module.exports = __webpack_public_path__ + "static/media/cta.48af03a1.svg";